import React from 'react';
import styled from 'styled-components';
import { LogoFull } from '@ui';
import { useCustomClient } from '@hooks/application/useCustomClient';
import { APP_COLOR_THEME_NAMES } from '@theme/appThemes';

export const TornadoLogoWrapper = styled.div`
  path {
    fill: ${({ theme }) => theme.themeColors.text};
  }
`;
export const CustomLogoWrapper = styled.div`
  svg {
    path {
      ${({ theme }) =>
        theme.colorThemeName === APP_COLOR_THEME_NAMES.darkProfessional ? 'fill: #fff !important;' : ''};
    }
  }
`;

const forceLogo = null;
/*
`
`;
*/

const CustomLogo = ({ logo }) => {
  return <CustomLogoWrapper dangerouslySetInnerHTML={{ __html: logo }}></CustomLogoWrapper>;
};

export const FullLogo = (props) => {
  const { isLoading, logo } = useCustomClient();

  if (props.forceTornado) {
    return (
      <TornadoLogoWrapper className={'logo-svg'}>
        <LogoFull {...props} />
      </TornadoLogoWrapper>
    );
  }

  if (isLoading) return null;

  if (logo || forceLogo) {
    return <CustomLogo logo={logo || forceLogo} />;
  }
  return (
    <TornadoLogoWrapper className={'logo-svg'}>
      <LogoFull {...props} />
    </TornadoLogoWrapper>
  );
};
